<template>
  <hm-content title="">
    <div slot="header">
      <hm-step :steps="steps" :step="2" disabledNext></hm-step>
    </div>
    <div>
      <div v-if="ruleForm.templateType === 'redMoney'" class="title">
        红包发放通知
      </div>
      <div v-if="ruleForm.templateType === 'rewardUp'" class="title">
        红包活动上线
      </div>
      <div v-if="ruleForm.templateType === 'rewardDown'" class="title">
        红包活动下线
      </div>
      <div v-if="ruleForm.templateType === 'dailyActivities'" class="title">
        红包活动定时推送
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="177px"
        class="demo-ruleForm"
      >
        <el-form-item label="模板名称：" prop="templateName">
          <el-input
            type="text"
            v-model.trim="ruleForm.templateName"
            clearable
            placeholder="请输入模板名称"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="消息类型：" prop="templateMode">
          <el-radio-group v-model="ruleForm.templateMode" size="small">
            <el-radio label="text">文本消息</el-radio>
            <el-radio label="img">图片消息</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="文字展示位置："
          prop="templateImgType"
          v-if="ruleForm.templateMode === 'img'"
        >
          <el-radio-group v-model="ruleForm.templateImgType" size="small">
            <el-radio label="upperPart">文字在图片头部</el-radio>
            <el-radio label="lowerPart">文字在图片尾部</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="上传图片："
          prop="templateImg"
          v-if="ruleForm.templateMode === 'img'"
        >
          <el-upload
            class="upload-massage flex"
            ref="upload"
            :show-file-list="false"
            drag
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :on-remove="handleRemove"
            :onError="uploadError"
            :onSuccess="uploadSuccess"
            :beforeUpload="beforeAvatarUpload"
            :onProgress="uploading"
            :on-change="handleChange"
          >
            <div class="priview" v-if="ruleForm.templateImg !== ''">
              <img :src="ruleForm.templateImg" alt="主图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
            <div>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
            </div>

            <div class="el-upload__tip" slot="tip">
              <span class="mr">
                上传图标注意：
                <br />1.图片尺寸750*1334
                <!-- <br />2.图片大小100k内 -->
                <br />2.图片格式：png、jpg、bmp
              </span>
              <div>
                <el-progress
                  v-if="progressFlag"
                  :percentage="loadProgress"
                ></el-progress>
              </div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="可用字段：" prop="templateName">
          <ul class="flex flex-wrap">
            <li
              v-for="(v, i) in msg"
              :key="i"
              @click="dd(i)"
              class="mr10 pointer"
            >
              <el-tag>{{ v.name }}({{ v.word }})</el-tag>
            </li>
          </ul>

          <div class="form-item-tip" style="color:red">
            编辑模板采用文字+可用字段的组合方式，编辑文本点击字段即可在文本对应位置插入需要动态字段形成专用模板
          </div>
          <!-- <el-input
            type="text"
            v-model.trim="ruleForm.templateName"
            clearable
            placeholder="请输入模板名称"
            size="small"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="设置想要发送的消息：" prop="templateText">
          <el-input
            class="mt20"
            ref="input"
            type="textarea"
            placeholder="请输入内容"
            style="width:500px"
            v-model="ruleForm.templateText"
            maxlength="500"
            show-word-limit
            :autosize="{ minRows: 10 }"
            @blur="getCursor"
          >
          </el-input>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="back"
            >上一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            :loading="isSaving"
            @click="submitRuleForm('ruleForm')"
            >确 认</el-button
          >
        </div>
      </el-form>
    </div>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import { setCookie, getCookie, removeCookie } from "@/utils/utils";
export default {
  components: { HmStep },
  data() {
    return {
      loadProgress: 0, // 动态显示进度条
      progressFlag: false, // 关闭进度条
      isSaving: false,
      msg: [],
      rules: {
        templateName: [
          {
            required: true,
            message: "请输入模板名称",
            trigger: "blur"
          },
          {
            required: true,
            min: 2,
            max: 20,
            message: "名称应大于2小于20个字",
            trigger: "blur"
          }
        ],
        templateText: {
          required: true,
          message: "请输入模板内容",
          trigger: "blur"
        },
        templateMode: {
          required: true,
          message: "请选择消息类型",
          trigger: "blur"
        },
        templateImg: {
          required: true,
          message: "请选择消息图片",
          trigger: "blur"
        },
        templateImgType: {
          required: true,
          message: "请选择文字图片显示的位置",
          trigger: "blur"
        }
      },
      ruleForm: {
        templateImgType: "",
        templateMode: "text",
        templateName: "",
        templateText: "",
        templateImg: ""
      },
      steps: [
        {
          link: "SendMsgRule",
          name: "选择模板类型"
        },
        {
          link: "SendRuleConfig",
          name: "新增模板"
        }
      ],
      start: 0,
      end: 0,
      isSize: true
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    const STEP = getCookie({ key: "TEMPSTEP" }) || {};
    if (STEP.hasOwnProperty("step2")) {
      for (let key in STEP.step2) {
        this.ruleForm[key] = STEP.step2[key];
      }
    }
    this.ruleForm.templateType = STEP.step1.templateType;
    this.queryRobotKeyWord();
  },
  methods: {
    handleChange(file) {
      if (file.status === "ready") {
        this.loadProgress = 0;
        this.progressFlag = true;
        const interval = setInterval(() => {
          if (this.loadProgress >= 99) {
            clearInterval(interval);
          }
        }, 20);
      }
      if (file.status === "success") {
        this.loadProgress = 100;
        setTimeout(() => {
          this.progressFlag = false;
        }, 1000);
      }
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.templateImg = "";
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.isSaving = false;
    },

    // 上传成功后的回调
    uploadSuccess(response) {
      this.ruleForm.templateImg = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
      this.isSaving = false;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      const limitSize = true;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 100k!",
          type: "warning"
        });
      }
      // let isSize = true;
      this.isSize = new Promise((resolve, reject) => {
        let width = 750;
        let height = 1334;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width >= width && img.height >= height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message({
            message: "图片最低像素为（宽*高）：750*1334",
            type: "warning"
          });
          setTimeout(() => {
            this.progressFlag = false;
          }, 1000);
          return Promise.reject();
        }
      );

      return (
        (extension || extension2 || extension3 || extension4) &&
        limitSize &&
        this.isSize
      );
    },
    getCursor(event) {
      this.start = event.target.selectionStart;
      this.end = event.target.selectionEnd;
    },
    async queryRobotKeyWord() {
      let params = {
        type:
          this.ruleForm.templateType === "redMoney"
            ? "redSendWord"
            : "redActWord"
      };
      const { result } = await this.$store.dispatch(
        "queryRobotKeyWord",
        params
      );
      this.msg = result;
    },
    dd(index) {
      const result =
        this.ruleForm.templateText.substring(0, this.start) +
        `${this.msg[index].word}` +
        this.ruleForm.templateText.substring(this.end);
      this.ruleForm.templateText = result;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          this.$store.dispatch("addWxMsgTemplateInfo", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              removeCookie({ key: "TEMPSTEP" });
              this.$router.push({
                name: "MessageTempManagement"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    back() {
      const data = getCookie({ key: "TEMPSTEP" });
      let step2 = this.ruleForm;
      Object.assign(data, { step2 });
      setCookie({ key: "TEMPSTEP", data });
      this.$router.push({
        name: "SendMsgRule",
        query: {
          type: "temp"
        }
      });
    }
  }
};
</script>
<style lang="scss">
.upload-massage {
  .el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 360px;
    height: 460px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
</style>
<style lang="scss" scoped>
.title {
  color: rgba(34, 34, 34, 1);
  margin-bottom: 10px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.priview {
  position: relative;
  width: 360px;
  height: 460px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
